import React from 'react';
import PropTypes from 'prop-types';
import Radio from '../../../shared/components/Radio/Radio';


const RadioVariants = function RadioVariantsComponent({ variationGroup, showVariationHandler }) {
  const radio = variationGroup.values.map((variation) => {
    const radioField = {
      label: variation.displayValue,
      ...variation,
    };

    return (
      <div className="product-details__radio-wrapper">
        <Radio
          key={variation.id}
          field={radioField}
          disabled={!variation.selectable}
          fieldName={variationGroup.attributeId}
          onChange={() => showVariationHandler(variation)}
        />
      </div>
    );
  });

  return (
    <fieldset key={variationGroup.id} className="product-details__variation-group">
      <legend className="product-details__variation-group__title">{variationGroup.displayName}</legend>
      {radio}
    </fieldset>
  );
};


RadioVariants.propTypes = {
  variationGroup: PropTypes.shape({}).isRequired,
  showVariationHandler: PropTypes.func.isRequired,
};

export default RadioVariants;
